import httpClient from './httpClient';

const prefix = 'checkin'

export default {
    async getCheckInByDriverId(id){
        const { data } = await httpClient({ requiresAuth: true }).get(`core/checkinDriver/`+id)
        return data
    },

    async getCheckInUserDashboard(time_start, time_end){
        const { data } = await httpClient({ requiresAuth: true }).get(`getCheckInUserDashboard?datetime=${time_start}-${time_end}`)
        return data
    },

    async createCheckIn(body){
        const { data } = await httpClient({ requiresAuth: true }).post(`core/createCheckIn`,body)
        return data
    }

}
